class WishlistListRequest extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.actioned = false

    this.onApproveClicked = this.onApproveClicked.bind(this)
    this.onDeclineClicked = this.onDeclineClicked.bind(this)

    this.listeners.add(this.els.approve.element, 'click', this.onApproveClicked)
    this.listeners.add(this.els.decline.element, 'click', this.onDeclineClicked)
  }

  async onApproveClicked (event) {
    event.preventDefault()

    if (this.actioned) return
    this.actioned = true

    this.els.actions.element.style.display = 'none'
    this.els.result.element.style.display = 'flex'
    this.els.resultApproved.element.style.display = 'block'

    await window.BAO.wishlist.acceptRequest(
      this.listId,
      this.collaboratorId,
      this.token,
    )
  }

  async onDeclineClicked (event) {
    event.preventDefault()

    if (this.actioned) return
    this.actioned = true

    this.els.actions.element.style.display = 'none'
    this.els.result.element.style.display = 'flex'
    this.els.resultDeclined.element.style.display = 'block'

    await window.BAO.wishlist.declineRequest(
      this.listId,
      this.collaboratorId,
      this.token,
    )
  }

  get listId () {
    return this.dataset.listId
  }

  get collaboratorId () {
    return this.dataset.collaboratorId
  }

  get token () {
    return window.BAO.wishlist.token
  }
}

if (!window.customElements.get('wishlist-list-request')) {
  window.customElements.define('wishlist-list-request', WishlistListRequest)
}
